export const CREATE_ADMIN_REGISTRATION_REQUEST = "CREATE_ADMIN_REGISTRATION_REQUEST";
export const CREATE_ADMIN_REGISTRATION_SUCCESS = "CREATE_ADMIN_REGISTRATION_SUCCESS";
export const CREATE_ADMIN_REGISTRATION_FAILURE = "CREATE_ADMIN_REGISTRATION_FAILURE";
